import React from 'react'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '@/app/store'
import SplashScreen from '@/components/shared/SplashScreen'

const AppLayout: React.FC = () => {
  const { settings } = useSelector((state: RootState) => state.settings)
  const isRTL = settings.language === 'ar'

  return (
    <div className={`flex h-full min-h-0 flex-col flutter-bg-app ${isRTL ? 'rtl' : 'ltr'}`}>
      <SplashScreen />
      {/* Main Content Area */}
      <main id="main-content" className="min-h-0 flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}

export default AppLayout
